import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = () => {
  const token = localStorage.getItem("dl_admin_token");
  return axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export function trackVisit() {
  try {
    // bez zgody na cookies analityczne — tylko licznik w pamięci strony, nic nie zapisujemy w przeglądarce (art. 399 PKE)
    const ok = localStorage.getItem("dl_cookie_consent") === "all";
    if (ok ? sessionStorage.getItem("dl_tracked") : window.__dlTracked) return;
    if (ok) sessionStorage.setItem("dl_tracked", "1"); else window.__dlTracked = true;
    let source = "bezpośrednie";
    const ref = document.referrer.toLowerCase();
    if (ref.includes("google")) source = "google";
    else if (ref.includes("facebook") || ref.includes("fb.")) source = "facebook";
    else if (ref.includes("instagram")) source = "instagram";
    else if (ref.includes("ceneo")) source = "ceneo";
    api.post("/analytics/track", { source, path: window.location.pathname }).catch(() => {});
  } catch (e) {}
}
